import {
    Component,
    AfterViewInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import { PaymentService } from '../payment.service';
import { Charge, Source, SubscriptionPlan } from '../models';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'payment-form',
    templateUrl: './payment-form.component.html',
    styleUrls: ['./payment-form.component.sass']
})
export class PaymentFormComponent implements AfterViewInit, OnDestroy {

    // Total amount of the charge
    @Input() totalAmount: number;

    // Emit result of operation to other components
    @Output() stripeResult = new EventEmitter<Charge | Source>();

    // Result used locacally to display status.
    result: Charge | Source;

    // The Stripe Elements Card
    @ViewChild('cardElement') cardElement: ElementRef;
    card: any;
    formError: string;
    formComplete = false;

    // State of async activity
    loading = false;
    action: Observable<any> = Observable.of(null);

    constructor(private cd: ChangeDetectorRef, public pmt: PaymentService) {
    }
    ngOnInit(){
    }

    ngAfterViewInit() {
        this.card = this.pmt.elements.create('card');
        this.card.mount(this.cardElement.nativeElement);

        // Listens to change event on the card for validation errors
        this.card.on('change', (evt) => {
            this.formError = evt.error ? evt.error.message : null;
            this.formComplete = evt.complete;
            this.cd.detectChanges();
        })
    }

    // Called when the user submits the form
    formHandler(): void {
        this.loading = true
        this.action = this.pmt.attachSource(this.card,'myFakeName');
        console.log("action = " ,this.action);
        this.action.subscribe( data => {
            console.log("action data = " ,data);
            if(!data) return;
            console.log('this.pmt.planId = ',this.pmt.planId)
            console.log('this.pmt.planQty = ',this.pmt.planQty)
            this.result = data;
            this.stripeResult.emit(data);
            this.loading = true;
            this.pmt.attachSubscription(data.id, this.pmt.planId, this.pmt.planQty).subscribe(result => {
                this.loading = false;
                console.log('attachSubscription returned');
            });
        }, err => {
            this.result = err;
            this.loading = false;
        });
    }
    ngOnDestroy() {
        this.card.destroy();
    }

}



// WEBPACK FOOTER //
// ./src/app/payment/payment-form/payment-form.component.ts